module.exports = "/packs/empty-progress-card-c40dd01c3ba27837722add6d13f80c09.png";